import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const { t, i18n } = useTranslation("global");
  const navigate = useNavigate();
  const location = useLocation();
  const isRtl = i18n.language === "ar";
  const fromHome =
    location.state?.from === "/" || location.state?.from === "";

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 px-3">
      <div className="card text-center shadow-sm p-5 border rounded-5 w-100" style={{ maxWidth: 480 }}>
        <img
          style={{ width: "auto", maxHeight: "80px", height: "80px" }}
          className="d-block mb-2 mx-auto"
          src="/warning.webp"
          width={120}
          height={80}
          alt={t("no_permission")}
          loading="lazy"
          decoding="async"
        />
        <h1 className="h5 text-danger fw-bold mb-3">{t("no_permission")}</h1>
        <div className="d-flex flex-wrap justify-content-center align-items-center gap-3">
          {fromHome ? (
            <button
              type="button"
              className="btn btn-link text-color p-0 text-decoration-none"
              onClick={() => navigate(-1)}
            >
              {isRtl ? "العودة للصفحة السابقة" : "Back to previous page"}{" "}
              <i
                className={`bi ${isRtl ? "bi-arrow-left" : "bi-arrow-right"} text-sm`}
              />
            </button>
          ) : (
            <Link className="text-color" to="/">
              {t("sidenav.home")}{" "}
              <i
                className={`bi ${isRtl ? "bi-arrow-left" : "bi-arrow-right"} text-sm`}
              />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
